import Splide from "@splidejs/splide";

const SPLIDE_OPTIONS = {
    perPage: 3,
    perMove: 1,
    gap: '1rem',
    pagination: false,
    breakpoints: { 768: { perPage: 2 }, 480: { perPage: 1 } },
};

function mountOrRemountSplide(root) {
    // root = élément .splide
    if (!root) return;
    // On garde la ref sur l’élément pour pouvoir destroy la prochaine fois
    if (root._splide) {
        root._splide.destroy(true);
    }
    root._splide = new Splide(root, SPLIDE_OPTIONS).mount();
}

export default class ModalCadencierMultiple extends HTMLDivElement {
    constructor() {
        super();
        this.submitButton = this.querySelector('.modal-footer button');
        this.productId = this.submitButton.dataset.productId;
        this.catalogueId = this.submitButton.dataset.catalogueId;
        this.currentModal = this;
    }

    connectedCallback() {
        this.addExceptionalDelivery();
    }

    addExceptionalDelivery() {
        if (!this.submitButton) return;

        this.submitButton.addEventListener('click', (event) => {
            event.preventDefault();

            const selectedDates = this.querySelectorAll('.b-date');
            selectedDates.forEach((selectedDate) => {
                const dateText = selectedDate.textContent.trim();
                const parts = dateText.split('/');
                selectedDate.value = (parts.length === 3)
                    ? `${parts[2]}-${parts[1].padStart(2,'0')}-${parts[0].padStart(2,'0')}`
                    : null;

                if (!selectedDate.value) return;

                // Injection ordonnée dans la liste
                const list = document.querySelector(`.card-dates-delivery[data-catalogue-id="${this.catalogueId}"][data-product-id="${this.productId}"] ul.splide__list`);
                if (!list) return;

                const allDates = list.querySelectorAll('li.splide__slide');
                const selectedDateObj = new Date(selectedDate.value);
                let exists = false;
                allDates.forEach(li => {
                    const qs = li.querySelector('quantity-selector');
                    if (qs && qs.dataset.date === selectedDate.value) exists = true;
                });
                if (exists) return;

                // Trouver la position d’insertion (tri chronologique ascendant)
                let inserted = false;
                let previous = null;
                allDates.forEach((li) => {
                    const current = new Date(li.querySelector('quantity-selector')?.dataset.date);
                    if (selectedDateObj < current && (!previous || selectedDateObj > previous)) {
                        const node = document.createElement('li');
                        node.className = 'splide__slide';
                        node.setAttribute('data-date', selectedDate.value);
                        node.setAttribute('data-quantity', '0');
                        node.innerHTML = `
                          <div class="text-center">
                            <label class="mb-2" for="dex-${this.catalogueId}-${selectedDate.value}">
                              <strong class="d-block">${new Date(selectedDate.value).toLocaleDateString('fr-FR', { weekday: 'long' })}</strong>
                              ${new Date(selectedDate.value).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })}
                            </label>
                            <quantity-selector role="group" class="small" data-date="${selectedDate.value}" data-exceptional="1">
                              <button class="btn border-0" type="button" aria-label="Diminuer la quantité"><i class="ri-subtract-line fs-8" aria-hidden="true"></i></button>
                              <input type="number" id="dex-${this.catalogueId}-${selectedDate.value}" class="form-control text-center" value="0" min="0" max="99" aria-label="Quantité" aria-describedby="quantity-description">
                              <button class="btn border-0" type="button" aria-label="Augmenter la quantité"><i class="ri-add-line fs-8" aria-hidden="true"></i></button>
                            </quantity-selector>
                          </div>`;
                        list.insertBefore(node, li);
                        inserted = true;
                    }
                    previous = new Date(li.querySelector('quantity-selector')?.dataset.date);
                });

                // Si c'est la plus grande (ou la plus petite) date et qu'on n'a pas inséré dans la boucle
                if (!inserted) {
                    const node = document.createElement('li');
                    node.className = 'splide__slide';
                    node.setAttribute('data-date', selectedDate.value);
                    node.setAttribute('data-quantity', '0');
                    node.innerHTML = `
                        <div class="text-center">
                          <label class="mb-2" for="dex-${this.catalogueId}-${selectedDate.value}">
                            <strong class="d-block">${new Date(selectedDate.value).toLocaleDateString('fr-FR', { weekday: 'long' })}</strong>
                            ${new Date(selectedDate.value).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })}
                          </label>
                          <quantity-selector role="group" class="small" data-date="${selectedDate.value}" data-exceptional="1">
                            <button class="btn border-0" type="button" aria-label="Diminuer la quantité"><i class="ri-subtract-line fs-8" aria-hidden="true"></i></button>
                            <input type="number" id="dex-${this.catalogueId}-${selectedDate.value}" class="form-control text-center" value="0" min="0" max="99" aria-label="Quantité" aria-describedby="quantity-description">
                            <button class="btn border-0" type="button" aria-label="Augmenter la quantité"><i class="ri-add-line fs-8" aria-hidden="true"></i></button>
                          </quantity-selector>
                        </div>`;
                    list.appendChild(node);
                }

                // (Re)monte Splide proprement
                const splideRoot = document.querySelector(`.card-dates-delivery[data-catalogue-id="${this.catalogueId}"][data-product-id="${this.productId}"] .splide`);
                mountOrRemountSplide(splideRoot);

                // 🔁 Actualise le composant CardQuantityDatesDelivery associé
                const qtyCard = document.querySelector(`div[is="card-quantity-dates-delivery"][data-catalogue-id="${this.catalogueId}"][data-product-id="${this.productId}"]`);
                if (qtyCard) {
                    try { customElements.upgrade?.(qtyCard); } catch(_) {}
                    qtyCard.reinit?.(); // re-snapshot + recalcul sans sync
                }
            });

            // Ferme la modal
            this.currentModal.querySelector('button.btn-close')?.click();
        });
    }
}
